export function matchesAdminSearch(query, ...values) {
  const needle = query.trim().toLocaleLowerCase("da-DK");
  return values.flat().some((value) => String(value ?? "").toLocaleLowerCase("da-DK").includes(needle));
}

export function AdminSearch({ label, value, onChange, count, total }) {
  return <div className="admin-list-toolbar">
    <label>{label}<input type="search" value={value} onChange={(event) => onChange(event.target.value)} placeholder="Skriv for at søge…"/></label>
    <p role="status">{count} af {total} i denne visning</p>
    {value && <button type="button" className="chip" onClick={() => onChange("")}>Ryd søgning</button>}
  </div>;
}

export function AdminStatus({ status, children }) {
  const tone = ["approved", "verified", "resolved", "completed", "published"].includes(status) ? "success" : ["rejected", "cancelled", "expired"].includes(status) ? "muted" : "pending";
  return <span className="admin-status" data-tone={tone}>{children}</span>;
}
